import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import download from '@helpers/download';

const TimelineEvent = (props) => {
  const { makeCurrentVersion, version, versionUploading } = props;
  const {
    action, currentVersion, downloadUrl, filename, height, mimeType, note, size, width,
    thumbnailUrl, updatedAt, updatedByEmail, updatedById, versionKey
  } = version;
  const versionEvent = action.toLowerCase().indexOf('check') === -1;
  const updatedAtTimePassed = moment(updatedAt).fromNow();
  const checkedOutClass = action === 'Checked out' ? 'checked-out' : '';
  let user = '';

  const dimensionsJSX = (
    <span>
      <span className="details-pipe">|</span>
      {`${width}px x ${height}px`}
    </span>
  );
  const memoryJSX = (
    <span>
      <span className="details-pipe">|</span>
      {size}
    </span>
  );

  if (updatedByEmail === 'unknown') {
    user = <span>{t('unknown')}</span>;
  } else if (BFG.currentUser.user_id === updatedById) {
    user = <span>{t('you')}</span>;
  } else {
    user = <a href="mailto:INPUT-EMAIL">{updatedByEmail}</a>;
  }

  const renderEventActions = () => {
    if (versionEvent) {
      let versionAction;

      if (currentVersion) {
        versionAction = <h4 className="italic-title">{t('Current version')}</h4>;
      } else {
        versionAction = (
          <button
            className="button tertiary update-version-button"
            disabled={versionUploading}
            onClick={() => makeCurrentVersion(versionKey)}
            type="button"
          >
            {t('Make current version')}
          </button>
        );
      }

      return (
        <div className="timeline-events__event-actions">
          {versionAction}
          <button
            className="button secondary download-button"
            onClick={() => download(downloadUrl, { filename, mimeType })}
            type="button"
          >
            <span className="bff-download-asset" />
          </button>
        </div>
      );
    }

    return <div className="timeline-events__event-actions" />;
  };

  return (
    <div className="timeline-events__event">
      <div className="timeline-events__event-image">
        <img src={thumbnailUrl} alt="attachment version thumbnail" />
      </div>
      <div className={`timeline-events__event-status ${checkedOutClass}`}>
        <span className="dot" />
        <div className="vertical-line" />
      </div>
      <div className="timeline-events__event-details">
        <h4>
          <span className="action">{action}</span>
          <span className="action-by">{t('by')}</span>
          {user}
          <span className="time-passed">{updatedAtTimePassed}</span>
        </h4>
        {note ? <h4 className="note">{`"${note}"`}</h4> : null}
        <h4 className="details-copy">
          <span>{filename}</span>
          <span>
            <span className="details-pipe">|</span>
            {moment(updatedAt).format('MM-DD-YYYY, h:mma')}
          </span>
          {width && height ? dimensionsJSX : null}
          {size ? memoryJSX : null}
        </h4>
      </div>
      {renderEventActions()}
    </div>
  );
};

export default TimelineEvent;

TimelineEvent.propTypes = {
  makeCurrentVersion: PropTypes.func.isRequired,
  version: PropTypes.shape({
    action: PropTypes.string,
    currentVersion: PropTypes.bool,
    downloadUrl: PropTypes.string,
    email: PropTypes.string,
    filename: PropTypes.string,
    height: PropTypes.number,
    mimeType: PropTypes.string,
    size: PropTypes.string,
    width: PropTypes.number,
    thumbnailUrl: PropTypes.string,
    updatedAt: PropTypes.string,
    versionKey: PropTypes.string
  }).isRequired,
  versionUploading: PropTypes.bool.isRequired
};
